var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"viewBox",attrs:{"id":"app"}},[_c(_vm.resolveLayout,{tag:"component",attrs:{"id":"app-container"}},[_c('router-view')],1),_c('AlertsList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }